<template>

  <!-- Notification -->
  <div class="fixed top-0 z-20 w-full p-2">
    <Notification
        v-for="notification in notifications"
        :key="notification"
        :notification="notification"/>
  </div>

  <!-- Current Active Factor -->
  <nav class="flex justify-between items-center px-4 py-2 shadow-sm text-white text-sm bg-gray-900"
       v-if="factor.taF_NAME">
    <span>{{ factor.taF_NAME }} <span class="text-yellow-300" v-if="editFactor">(ویرایش)</span></span>
    <span>تعداد: {{ factor.tedad }}</span>
    <span>میز: {{ factor.desK_NUMBER }}</span>
  </nav>


  <LoadingProgressBar/>

  <router-view/>

  <div class="h-16" v-if="$route.name !== 'Login'"></div>

  <!--  Bottom Navigation Menu -->
  <nav v-if="this.$route.path !== '/login'"
       class="flex fixed bottom-0 w-full justify-between p-2 pb-1 bg-gray-900 text-gray-200 border-yellow-500 border-t text-center z-20 lg:hidden">
    <div>
      <router-link to="/submit-order" :class="{'text-gray-600' : user.role !== 'Waiter' && user.role !== 'Admin'}">
        <ClipboardListIcon class="h-6 w-6 mx-auto"/>
        <span class="text-xs">سفارش</span>
      </router-link>
    </div>
    <div>
      <router-link to="/menu">
        <BookOpenIcon class="h-6 w-6 mx-auto"/>
        <span class="text-xs">منو</span>
      </router-link>
    </div>
    <div>
      <router-link to="/">
        <HomeIcon class="h-6 w-6 mx-auto"/>
        <span class="text-xs">خانه</span>
      </router-link>
    </div>
    <div>
      <router-link to="/my-factors" :class="{'text-gray-600' : user.role !== 'Waiter' && user.role !== 'Admin'}">
        <CollectionIcon class="h-6 w-6 mx-auto"/>
        <span class="text-xs">فاکتور ها</span>
      </router-link>
    </div>
    <div>
      <router-link to="/note-list" :class="{'text-gray-600' : user.role !== 'Manager' && user.role !== 'Admin'}">
        <BookmarkIcon class="h-6 w-6 mx-auto"/>
        <span class="text-xs">یادداشت</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
import {BookmarkIcon, BookOpenIcon, ClipboardListIcon, CollectionIcon, HomeIcon} from '@heroicons/vue/outline'
import {mapGetters, mapState} from "vuex";
import LoadingProgressBar from "@/components/Loading-ProgressBar";
// import * as signalR from "@microsoft/signalr"
import Notification from "./components/General/Notification";
import {getMessaging, onMessage} from "firebase/messaging";
import firebaseApp from "./utils/firebase";

export default {
  name: "App",
  components: {
    Notification,
    ClipboardListIcon,
    HomeIcon,
    LoadingProgressBar,
    CollectionIcon,
    BookOpenIcon,
    BookmarkIcon
  },
  data() {
    return {
      notifications: [],
    }
  },
  computed: {
    ...mapState(['factor']),
    ...mapState(['user']),
    ...mapGetters(['editFactor'])
  },
  mounted() {
    // const connection = new signalR.HubConnectionBuilder()
    //     .withUrl("http://192.168.87.61:8088/chatHub", {
    //       withCredentials: false,
    //     })
    //     .configureLogging(signalR.LogLevel.Information)
    //     .build();
    //
    // connection.start()

    // connection.on("ReceiveMessage", (type, message) => {
    //   message = JSON.parse(message);
    //
    //   if (type === 'Charge' || type === 'All') {
    //     if (message.SIGNAL_TO_CAPTAIN_ID == this.$store.state.user.username) {
    //       let audio = new Audio(require('./assets/notification.wav'));
    //       audio.play();
    //       navigator.vibrate([200, 200, 200, 200, 400])
    //       this.notifications.push(message)
    //     }
    //   }
    //   console.log(message)
    // });

    const messaging = getMessaging(firebaseApp);
    onMessage(messaging, (payload) => {
      let audio = new Audio(require('./assets/notification.wav'));
      audio.play();
      navigator.vibrate([200, 200, 200, 200, 400])
      this.notifications.push(payload.notification.body)
    });

  },
}
</script>
<style>
@font-face {
  font-family: 'iransans';
  src: url('assets/font/iran_sans.ttf');
}

* {
  -webkit-tap-highlight-color: transparent;
}

html, body {
  font-family: 'iransans' !important;
  direction: rtl;
  @apply bg-gray-800 text-gray-800
}

.router-link-active {
  @apply text-yellow-500
}

select:invalid {
  color: gray
}

/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}

.slide-enter-from {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
